<template>

<div class="foot">

	<slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.foot {
	padding: 10px 15px;
	display: grid;
	grid-gap: 10px;
	flex-shrink: 0;
	z-index: 2;
	background-color: #19455c;
	grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.is-mobile .foot {
	padding: 10px;
	background-color: #fff;
	border-top: 1px solid #eee;
}

.foot:empty {
	display: none;
}

.foot:empty {
	display: none;
}

</style>